import React, { FC } from 'react';
import Layout from '@common/layout';
import AccaAgree from '@components/accaAgree';

const AccaAgreePage: FC = () => {
  return (
    <Layout>
      <AccaAgree />
    </Layout>
  );
};

export default AccaAgreePage;
